import dayjs from 'dayjs';

import { SECONDS_IN_DAY } from '@cast/constants';

export const isCrossAzDateRangeSupported = (
  from: string,
  to: string
): boolean => dayjs(to).diff(dayjs(from), 'second', true) > SECONDS_IN_DAY;
